import React from "react";
import useAuth from "../../Hooks/useAuth";

const Wallet = () => {
  const {showDummyImage} = useAuth()
  const openInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };
  return (
    <section className="wallet">
      <div className="container">
        <div className="wallet-wrapper">
          <div className="wallet-left">
            <img src={require("../../assets/images/login/login.png")} alt={'login'}  onError={({ currentTarget },imageSize = "520X570") => showDummyImage({ currentTarget }, imageSize)}/>
          </div>
          <div className="wallet-right">
            <div className="wallet-right-content">
              <h2 className="pageTitle">
                Connect your wall<span>et</span>
              </h2>
              <p>
                Sign in with one of available wallet providers or create a new
                wallet.
              </p>
            </div>
            <div className="each-wallet">
              <button
                className="wallet-btn"
                onClick={() => openInNewTab("https://tor.us/")}
              >
                <div className="wallet-icon">
                  <img src={require("../../assets/images/common/torus.png")} alt={'torus'} onError={({ currentTarget },imageSize = "25X25") => showDummyImage({ currentTarget }, imageSize)}/>
                </div>
                Torus
              </button>
              <button
                className="wallet-btn"
                onClick={() => openInNewTab("https://metamask.io/")}
              >
                <div className="wallet-icon">
                  <img src={require("../../assets/images/common/metamask.png")} alt={'metamask'} onError={({ currentTarget },imageSize = "25X25") => showDummyImage({ currentTarget }, imageSize)} />
                </div>
                Metamask
              </button>
              <button
                className="wallet-btn"
                onClick={() => openInNewTab("https://www.coinbase.com/wallet")}
              >
                <div className="wallet-icon">
                  <img src={require("../../assets/images/common/coinbase.png")} alt={'coinbase'} onError={({ currentTarget },imageSize = "25X25") => showDummyImage({ currentTarget }, imageSize)} />
                </div>
                Coinbase
              </button>
              <button
                className="wallet-btn"
                onClick={() => openInNewTab("https://www.coinbase.com/wallet")}
              >
                <div className="wallet-icon">
                  <img src={require("../../assets/images/common/mobile-wallet.png")} alt={'mobileWallet'} onError={({ currentTarget },imageSize = "25X25") => showDummyImage({ currentTarget }, imageSize)} />
                </div>
                Mobile-Wallet
              </button>
            </div>
            <p className="wallet-right-para">
              We do not own your private keys and cannot access your funds
              without your confirmation.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Wallet;
